import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'knowDesc'
})

export class KnowDescPipe implements PipeTransform {

  private descMap = {
    'score': `The overall quality of your air is determined by 5 factors: chemicals, carbon dioxide (CO₂), dust, humidity, and temperature. We weigh the importance of each of those sensors based on the preference you’ve selected for your device. Our preferences include general, allergy, sleep, productivity, and baby. Awair compiles all the information about your air quality into a simple score you can check at a glance.`,

    'temp': `Studies have shown that significant changes in temperature can make it difficult to complete physical and mental tasks, decreasing overall productivity. <br>
    When temperatures are high, chemicals typically found in building materials will leach into the air at a faster rate.`,

    'humid': `Humidity plays an important role in overall comfort, and too high or low humidity can cause a variety of health problems.<br>
    High humidity can lead to mold and mildew growth in your building, and can cause side effects such as heat exhaustion and dehydration.<br>
    Alternately, low humidity can cause static electricity and eye, nose, skin, and throat irritation.`,

    'co2': `Although it has a bit of a reputation, carbon dioxide is a natural component of our air. Too much carbon dioxide, however, can cause drowsiness, headaches, decreased productivity, and poor sleep quality.`,

    'voc': `The chemicals in our air that Awair tracks are typically referred to as VOCs (volatile organic compounds). VOCs evaporate easily at room temperature, and have been known to cause a variety of health problems, including eczema flare ups, allergies, asthma, and headaches.`,

    'dust': `Dust triggers allergies for millions of people, and unlike pollen, dust can occur year-round. One piece of dust can contain any combination of dead skin, mold spores, pieces of dead insects, and pet dander.<br>
    Dust can cause itchiness, asthma, eczema, and hay fever. Exposure to dust mites has also been linked to conjunctivitis, hypersensitive pneumonia, and both allergic and migraine headaches.`,

    'pm25': `Your Omni measures fine particles in your air classified as PM2.5. Particles that are 2.5 microns in width are able to travel into the respiratory tract, causing short-term irritation and potential long-term health effects. These particles are typically caused by pollution from vehicle exhaust, burning wood, natural fires, smoking, and cooking.`
  };

  transform(componentType: string): any {
    return this.descMap[componentType];
  }
}
